import { useContext } from 'react';
import { useSlate } from 'slate-react';
import { Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';
import { TagContext } from 'app/state/contexts/TagContext';
import { useEditorSelector } from 'app/state/contexts/EditorContext';
import { useDeleteFootnote } from 'app/api/tag-queries';
import { footnoteSnippet, removeFootnote } from 'app/slate/extensions/tag/utils/footnote';

export const FootnotePanel = () => {
  const editor = useSlate();
  const { pDocument } = useEditorSelector((e: any) => e);
  const { selectedFootnoteId, setSelectedFootnoteId } = useContext(TagContext) as any;
  const { mutate: deleteFootnote } = useDeleteFootnote();

  if (!selectedFootnoteId) return null;

  const snippet = footnoteSnippet(editor, selectedFootnoteId) ?? '';

  const handleRemove = () => {
    removeFootnote(editor, selectedFootnoteId);
    deleteFootnote({ id: selectedFootnoteId, documentSuperId: pDocument?.superId });
    setSelectedFootnoteId(null);
  };

  return (
    <section className="p-3 w-100">
      <Typography variant="body-7" fontWeight="semibold">
        {i18n('tag.footnotes.title')}
      </Typography>
      <Typography variant="body-7" fontWeight="light" style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {snippet}
      </Typography>
      <div className="mt-2">
        <button className="btn btn-secondary" onClick={handleRemove}>
          {i18n('tag.footnote.remove')}
        </button>
        <button className="btn btn-link" onClick={() => setSelectedFootnoteId(null)}>
          {i18n('common.cancel')}
        </button>
      </div>
    </section>
  );
};
